"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabsHeaderItem = exports.StyledTabsHeader = exports.StyledTabsBody = exports.StyledTabs = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tachyons = require("../../framework/tachyons");

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var StyledTabs = _styledComponents["default"].div.withConfig({
  displayName: "Tabsstyles__StyledTabs",
  componentId: "sc-olqdln-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])([""]))));

exports.StyledTabs = StyledTabs;

var StyledTabsHeader = _styledComponents["default"].header.withConfig({
  displayName: "Tabsstyles__StyledTabsHeader",
  componentId: "sc-olqdln-1"
})(["", " & nav{", " ", "{overflow-x:scroll;}& ul{", "}}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["bb b--gray"]))), (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["overflow-hidden"]))), _tachyons.breakpoints.s, (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["list ma0 pa0 flex"]))));

exports.StyledTabsHeader = StyledTabsHeader;

var StyledTabsHeaderItem = _styledComponents["default"].li.withConfig({
  displayName: "Tabsstyles__StyledTabsHeaderItem",
  componentId: "sc-olqdln-2"
})(["transition:all 0.3s ease-in-out;", " &:hover{background-color:rgb(255,244,237);", "}& a{", " &:hover{text-decoration:none;}}"], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    bb bw2 nowrap\n    ", "\n  "])), function (_ref) {
  var active = _ref.active;
  return active ? 'b--orange' : 'b--white';
}), function (_ref2) {
  var active = _ref2.active;
  return !active && 'border-color: rgb(254 212 185);';
}, (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n      pa3 dib f4 no-underline\n      ", "\n    "])), function (_ref3) {
  var active = _ref3.active;
  return active ? 'black' : 'dark-gray';
}));

exports.StyledTabsHeaderItem = StyledTabsHeaderItem;

var StyledTabsBody = _styledComponents["default"].section.withConfig({
  displayName: "Tabsstyles__StyledTabsBody",
  componentId: "sc-olqdln-3"
})(["", ""], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["pa3 black"]))));

exports.StyledTabsBody = StyledTabsBody;